import { ParamConfig } from "../../../utils/params/ParamsConfig";
import { isBooleanTrue } from "../../../../../core/BooleanValue";
import { NodeContext } from "../../../../poly/NodeContext";
const CallbackOptions = {
  computeOnDirty: false,
  callback: (node) => {
    SceneEnvController.update(node);
  }
};
export function SceneEnvParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.useEnvironment = ParamConfig.BOOLEAN(0, {
        ...CallbackOptions,
        separatorBefore: true
      });
      this.environment = ParamConfig.NODE_PATH("", {
        visibleIf: { useEnvironment: 1 },
        nodeSelection: {
          context: NodeContext.COP
        },
        dependentOnFoundNode: false,
        ...CallbackOptions
      });
    }
  };
}
export class SceneEnvController {
  constructor(node) {
    this.node = node;
  }
  async update() {
    const scene = this.node.object;
    const pv = this.node.pv;
    if (isBooleanTrue(pv.useEnvironment)) {
      const node = pv.environment.nodeWithContext(NodeContext.COP);
      if (node) {
        node.compute().then((container) => {
          scene.environment = container.texture();
        });
      } else {
        this.node.states.error.set("bgTexture node not found");
      }
    } else {
      scene.environment = null;
    }
  }
  static async update(node) {
    node.sceneEnvController.update();
  }
}
